import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.support-inbox.views.SupportInboxView.';

  public static readonly currentAll = `${Id.prefix}currentAll`;
  public static readonly quoteReviews = `${Id.prefix}quoteReviews`;
  public static readonly supportRequests = `${Id.prefix}supportRequests`;
  public static readonly specialItemRequests = `${Id.prefix}specialItemRequests`;
  public static readonly archived = `${Id.prefix}archived`;
}

export class LangSupportInboxView {
  private constructor() {}

  public static currentAll(): string {
    return interpolate(Id.currentAll);
  }

  public static quoteReviews(): string {
    return interpolate(Id.quoteReviews);
  }

  public static supportRequests(): string {
    return interpolate(Id.supportRequests);
  }

  public static specialItemRequests(): string {
    return interpolate(Id.specialItemRequests);
  }

  public static archived(): string {
    return interpolate(Id.archived);
  }
}

export class SupportInboxViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.currentAll, 'Current (All)', 'Tab caption for all current support tickets');
    register.add(Id.quoteReviews, "{{glossary 'quote'}} Reviews", 'Tab caption for quote reviews');
    register.add(Id.supportRequests, "{{glossary 'support-request:plural'}}", 'Tab caption for support requests');
    register.add(
      Id.specialItemRequests,
      "{{glossary 'special-item-request:plural'}}",
      'Tab caption for special item requests'
    );
    register.add(Id.archived, 'Archived', 'Tab caption for archived items');
  }
}
